import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _8bf49552 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _5082f0e2 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _030c1c9c = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _3a83da2c = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _59e116cc = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _5afe8b2a = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _75406668 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _69046543 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _0bcad4e8 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _56626c2d = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _5c7a0341 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _36fecb6f = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _028c4975 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _10db2dcc = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _436b4f44 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _27b937a2 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _706b4954 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _36c40e0c = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _1c51fe62 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _19cb5fa2 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _384f6ab6 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _0e585566 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _8b0b1ccc = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _cbd036da = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _a8e256ce = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _0349ae2c = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _4db1c524 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _2c1ce9d8 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _904e5d1c = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _58982fb6 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _1c9db426 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _15963580 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _452daac9 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _0c942b01 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _83213afa = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _40a62581 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _8097b948 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _b004edbc = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _46543348 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _73b7da14 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _07632714 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _da4a08c0 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _f45c6dc2 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _3675c624 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _40c6ad1e = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _095b713d = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _70b3fae7 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _52664881 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _37e06ec9 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _2ebb6c6a = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _1ec894dc = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _7a27065a = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _0871ae45 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _5c244892 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3092d4ea = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _071e30cf = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _0f9e67b4 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _483dd0ab = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _3990b79a = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _09d516c5 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _dfea90ae = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _9e617b08 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _1089cb71 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _3182f9a9 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _3d6b4cc4 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _655f217f = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _12dcb89a = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _6da58ea8 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _8fc34798 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _9baeea18 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _f4fc3c2e = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _775f1ce5 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _fff0730e = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _becfd4b2 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _37329c31 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _0156dd97 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _8bf49552,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _5082f0e2,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _030c1c9c,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _3a83da2c,
    name: "calendar"
  }, {
    path: "/customer",
    component: _59e116cc,
    name: "customer"
  }, {
    path: "/details",
    component: _5afe8b2a,
    name: "details"
  }, {
    path: "/goals",
    component: _75406668,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _69046543,
    name: "maisoku"
  }, {
    path: "/media",
    component: _0bcad4e8,
    name: "media"
  }, {
    path: "/privacy",
    component: _56626c2d,
    name: "privacy"
  }, {
    path: "/project",
    component: _5c7a0341,
    name: "project"
  }, {
    path: "/response",
    component: _36fecb6f,
    name: "response"
  }, {
    path: "/sale",
    component: _028c4975,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _10db2dcc,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _436b4f44,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _27b937a2,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _706b4954,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _36c40e0c,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _1c51fe62,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _19cb5fa2,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _384f6ab6,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _0e585566,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _8b0b1ccc,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _cbd036da,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _a8e256ce,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _0349ae2c,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _4db1c524,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _2c1ce9d8,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _904e5d1c,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _58982fb6,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _1c9db426,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _15963580,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _452daac9,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _0c942b01,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _83213afa,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _40a62581,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _8097b948,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _b004edbc,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _46543348,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _73b7da14,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _07632714,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _da4a08c0,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _f45c6dc2,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _3675c624,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _40c6ad1e,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _095b713d,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _70b3fae7,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _52664881,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _37e06ec9,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _2ebb6c6a,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _1ec894dc,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _7a27065a,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _0871ae45,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _5c244892,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _3092d4ea,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _071e30cf,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _0f9e67b4,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _483dd0ab,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _3990b79a,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _09d516c5,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _dfea90ae,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _9e617b08,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _1089cb71,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _3182f9a9,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _3d6b4cc4,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _655f217f,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _12dcb89a,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _6da58ea8,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _8fc34798,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _9baeea18,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _f4fc3c2e,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _775f1ce5,
    name: "property-property",
    children: [{
      path: "contact",
      component: _fff0730e,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _becfd4b2,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _37329c31,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _0156dd97,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
